import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import {HttpStatus, Status} from "../../common/Constants";
import MasterLocatorModifying from "./components/MasterApprovalModifying";
import MasterApprovalFilter from "./components/MasterApprovalFilter";
import {formGroupApproval} from "./config";
import Api from "../../../Services/Api";
import ToggleButton from "react-toggle-button";
import {flattenFormGroupObject, getValueFromDDL, removeNullFields} from "../../common/mapper";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";

class MasterApproval extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "approvalId",
            label: "ID Pelanggaran",
        },
        {
            name: "approvalDescription",
            label: "Deskripsi Pelanggaran",
        },
        {
            name: "approvalAhassLine",
            label: "Ahas Line",
        },
        {
            name: "approvalMarketingLine",
            label: "Mkt Line",
        },
        {
            name: "approvalAdminLine",
            label: "Adm Line",
        },
        {
            name: "",
            label: "Aksi",
            options: {
                customBodyRender: (_, tableMeta) => {
                    return (
                        <FlexView vAlignContent="center">
                            <SimpleButton
                                category="action_button"
                                style={{marginRight: 15, backgroundColor: "transparent"}}
                                icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lw fa-pencil-alt"/>}
                                onClick={() => this.handleModifyingModalVisibility(tableMeta.rowIndex)}
                            />
                            <ToggleButton
                                value={R.equals(this.state.dataTable[tableMeta.rowIndex].status, "ACTIVE")}
                                onToggle={(value) => this.handleChangeStatus(tableMeta.rowIndex, !value)}
                            />
                            {/*{this.props.menuAccess && this.props.menuAccess.updateAccess && (*/}
                            {/*    <SimpleButton*/}
                            {/*        category="action_button"*/}
                            {/*        style={{marginRight: 15, backgroundColor: "transparent"}}*/}
                            {/*        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lw fa-pencil-alt"/>}*/}
                            {/*        onClick={() => this.handleModifyingModalVisibility(tableMeta.rowIndex)}*/}
                            {/*    />*/}
                            {/*)}*/}
                            {/*{this.props.menuAccess && this.props.menuAccess.updateAccess && (*/}
                            {/*    <ToggleButton*/}
                            {/*        value={R.equals(this.state.dataTable[tableMeta.rowIndex].status, "ACTIVE")}*/}
                            {/*        onToggle={(value) => this.handleChangeStatus(tableMeta.rowIndex, !value)}*/}
                            {/*    />*/}
                            {/*)}*/}
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.initialFilterData = {
            approvalid: null,
            approvaldescription: null,
            approvalahassline: null,
            approvalmarketingline: null,
            approvaladminline: null,
            status: Status.INACTIVE,
        };
        this.initialSearch = {
            approvaldescription: null,
        };
        this.state = {
            loading: false,
            filterVisible: false,
            modifyingVisible: false,
            selectedData: null,
            filterData: this.initialFilterData,
            search: this.initialSearch,
            submittedFilterData: {},
            dataTable: [],
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataApproval();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: !R.isNil(index) ? {...prevValue.dataTable[index]} : null,
            modifyingVisible: !prevValue.modifyingVisible,
        }));
    };

    handleModalFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        this.handleClearSearch();
        this.handleModalFilterVisibility();
        let req = removeNullFields(this.parseFilterData(this.state.filterData));
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: req,
        }));
        await this.fetchDataApproval({
            paramFilters: req,
            limit: this.state.pagination.limit,
            page: 1
        });
        this.handleTriggerLoading();

    };

    refetch = async () => {
        let paramFilters;
        if (!R.isEmpty(this.state.submittedFilterData)) {
            paramFilters = removeNullFields(this.parseFilterData(this.state.submittedFilterData));
        } else {
            paramFilters = removeNullFields(this.state.search);
        }
        await this.fetchDataApproval({
            paramFilters: paramFilters,
            page: this.state.pagination.page,
            limit: this.state.pagination.limit
        });
    }

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            approvalAhassLine: getValueFromDDL(formGroup, "approvalAhassLine"),
            approvalMarketingLine: getValueFromDDL(formGroup, "approvalMarketingLine"),
            approvalAdminLine: getValueFromDDL(formGroup, "approvalAdminLine"),
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").saveMasterApproval,
            menuName: "Master Approval",
            setError: this.props.setError,
            args: requestBody
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            // this.setState((prevValue) => ({
            //     ...prevValue,
            //     submittedFilterData: {},
            //     filterData: this.initialFilterData,
            //     search: this.initialSearch,
            // }));
            await this.refetch();
        }
        this.handleTriggerLoading();
    };

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({...prevValue, submittedFilterData: {},}))
        await this.fetchDataApproval({
            paramFilters: removeNullFields(this.state.search),
            limit: this.state.pagination.limit,
            page: 1
        });
        this.handleTriggerLoading();
        this.handleClearFilter();
    }

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        let requestBody = {
            approvalId: data.approvalId,
            status: value ? "ACTIVE" : "INACTIVE",
        }
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusMasterApproval,
            menuName: "Master Approval",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            // this.setState((prevValue) => ({
            //     ...prevValue,
            //     submittedFilterData: {},
            //     filterData: this.initialFilterData,
            //     search: this.initialSearch,
            // }));
            await this.refetch();
        }
        this.handleTriggerLoading();
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleValueChangeSearch = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleClearFilter = () => {
        this.setState((prevValue) => ({...prevValue, filterData: this.initialFilterData}));
    };

    handleClearSearch = () => {
        this.setState((prevValue) => ({...prevValue, search: this.initialSearch}));
    };

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));

        let paramFilters;
        if (!R.isEmpty(this.state.submittedFilterData)) {
            paramFilters = removeNullFields(this.parseFilterData(this.state.submittedFilterData));
        } else {
            paramFilters = removeNullFields(this.state.search);
        }
        await this.fetchDataApproval({
            paramFilters: paramFilters,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                count: 1,
                page: 1,
                limit: limit,
            }
        }));

        let paramFilters;
        if (!R.isEmpty(this.state.submittedFilterData)) {
            paramFilters = removeNullFields(this.parseFilterData(this.state.submittedFilterData));
        } else {
            paramFilters = removeNullFields(this.state.search);
        }
        await this.fetchDataApproval({
            paramFilters: paramFilters,
            page: 1,
            limit: limit
        });
        // await this.fetchDataApproval({paramFilters: {}, page: 1, limit: limit});
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataApproval = async (body) => {
        this.setState((prevValue) => ({...prevValue, pagination: {...prevValue.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0 ?
            body :
            {paramFilters: {}, page: 1, limit: 5};
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterApprovalFindByParam,
            menuName: "Master Approval",
            setError: this.props.setError,
            args: req,
        });

        if (response.ok || (!R.isEmpty(response.data) && !R.isNil(response.data)) && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data.data,
                pagination: {
                    ...prevValue.pagination,
                    count: response.data.totalData ? response.data.totalData : 0,
                    page: req?.page || 1,
                    limit: req?.limit || 5,
                }
            }));
        }
    }

    parseFilterData(data) {
        return {
            ...data,
            approvalahassline: getValueFromDDL(data, "approvalahassline"),
            approvalmarketingline: getValueFromDDL(data, "approvalmarketingline"),
            approvaladminline: getValueFromDDL(data, "approvaladminline"),
            status: getValueFromDDL(data, "status"),
        };
    }

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{justifyContent: "space-between"}} className="margin-bottom-5px margin-top-5px">
                        <FlexView vAlignContent="center" className="margin-bottom-5px">
                            <SimpleInput
                                type="text"
                                name="approvaldescription"
                                placeholder="Deskripsi pelanggaran"
                                containerclassname="margin-bottom-none"
                                onChange={(e) => this.handleValueChangeSearch(e.target.name, e.target.value)}
                                value={this.state.search.approvaldescription}
                            />
                            <SimpleButton onClick={this.handleSubmitSearch}
                                          className="margin-top-5px">Cari</SimpleButton>
                        </FlexView>
                        <SimpleButton
                            onClick={this.handleModalFilterVisibility}
                            styles={{width: "unset", marginTop: "5px"}}
                            icon={<i className={"fa fa-qrcode"}></i>}
                        />
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.pagination.count}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(
                            (tableState) => this.handleChangePage(tableState),
                            (tableState) => this.handleChangeRowsPerPage(tableState),
                        )}
                        footerAdditionalButtons={
                            <>
                                {/*{*/}
                                {/*    this.props.menuAccess && this.props.menuAccess.createAccess && (*/}
                                {/*        <SimpleButton*/}
                                {/*            onClick={() => this.handleModifyingModalVisibility()}*/}
                                {/*            icon={<i className="fa fa-plus margin-right-10px"></i>}*/}
                                {/*            text={"Tambah"}*/}
                                {/*        />*/}
                                {/*    )*/}
                                {/*}*/}

                                {/* <SimpleButton
                                    onClick={() => this.handleModifyingModalVisibility()}
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    text={"Tambah"}
                                /> */}
                            </>
                        }
                    />
                </Container>

                {this.state.modifyingVisible && (
                    <MasterLocatorModifying
                        formGroup={formGroupApproval}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onClickClose={this.handleModifyingModalVisibility}
                        onSubmit={this.handleSubmitModifying}
                    />
                )}

                {this.state.filterVisible && (
                    <MasterApprovalFilter
                        selectedData={this.state.filterData}
                        visible={this.state.filterVisible}
                        onClickClose={this.handleModalFilterVisibility}
                        onClearFilter={this.handleClearFilter}
                        onValueChange={this.handleValueChange}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterApproval);